import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var PasteIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.912 38.33C18.912 37.8434 19.3066 37.449 19.7933 37.449H34.6583C35.145 37.449 35.5396 37.8434 35.5396 38.33C35.5396 38.8165 35.145 39.2109 34.6583 39.2109H19.7933C19.3066 39.2109 18.912 38.8165 18.912 38.33Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.912 30.284C18.912 29.7975 19.3066 29.4031 19.7933 29.4031H34.6583C35.145 29.4031 35.5396 29.7975 35.5396 30.284C35.5396 30.7706 35.145 31.165 34.6583 31.165H19.7933C19.3066 31.165 18.912 30.7706 18.912 30.284Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3386 22.2499C26.3386 21.7633 26.7332 21.3689 27.2199 21.3689H34.6583C35.145 21.3689 35.5396 21.7633 35.5396 22.2499C35.5396 22.7364 35.145 23.1308 34.6583 23.1308H27.2199C26.7332 23.1308 26.3386 22.7364 26.3386 22.2499Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1928 9.88147V37.7896H11.3914C11.8782 37.7896 12.2727 38.1841 12.2727 38.6706C12.2727 39.1571 11.8782 39.5515 11.3914 39.5515H10.1693C9.22043 39.5515 8.43018 38.7891 8.43018 37.8131V9.85798C8.43018 8.90951 9.19293 8.11959 10.1693 8.11959H31.3915C32.3404 8.11959 33.1307 8.88202 33.1307 9.85798V11.3967C33.1307 11.8832 32.7361 12.2776 32.2493 12.2776C31.7626 12.2776 31.368 11.8832 31.368 11.3967V9.88147H10.1928ZM10.1928 9.85798C10.1928 9.85792 10.1928 9.85784 10.1928 9.85798V9.85798Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1067 16.3417L16.6323 23.8128V44.2381H37.8075V16.3417H24.1067ZM22.9187 15.0375C23.2214 14.735 23.6255 14.5798 24.0354 14.5798H37.9838C38.8583 14.5798 39.5702 15.2914 39.5702 16.1655V44.4143C39.5702 45.2885 38.8583 46 37.9838 46H16.4561C15.5816 46 14.8697 45.2885 14.8697 44.4143V23.7416C14.8697 23.3318 15.0249 22.9279 15.3276 22.6253L22.9187 15.0375Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7652 14.5798C24.2519 14.5798 24.6465 14.9742 24.6465 15.4608V22.7549C24.6465 23.6291 23.9346 24.3406 23.0601 24.3406H15.7628C15.276 24.3406 14.8814 23.9462 14.8814 23.4597C14.8814 22.9732 15.276 22.5788 15.7628 22.5788H22.8838V15.4608C22.8838 14.9742 23.2784 14.5798 23.7652 14.5798Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7653 4.52536C17.4846 3.04258 18.9897 2 20.7687 2C22.5476 2 24.0527 3.04258 24.7721 4.52536H26.9967C27.4834 4.52536 27.878 4.91977 27.878 5.4063V9.01228C27.878 9.49881 27.4834 9.89322 26.9967 9.89322C26.5099 9.89322 26.1153 9.49881 26.1153 9.01228V6.28724H24.1764C23.7916 6.28724 23.4512 6.0376 23.3357 5.67061C22.9862 4.55977 21.9717 3.76188 20.7687 3.76188C19.5656 3.76188 18.5511 4.55977 18.2016 5.67061C18.0861 6.0376 17.7458 6.28724 17.3609 6.28724H15.422V9.01228C15.422 9.49881 15.0274 9.89322 14.5407 9.89322C14.0539 9.89322 13.6593 9.49881 13.6593 9.01228V5.4063C13.6593 4.91977 14.0539 4.52536 14.5407 4.52536H16.7653Z"
  }));
});
PasteIcon.displayName = 'PasteIcon';
PasteIcon.defaultProps = {
  'aria-label': 'Paste'
};
export default PasteIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/PasteIcon/index.js
// module id = 1910
// module chunks = 12